import 'rxjs/add/observable/fromPromise';
import {Observable} from 'rxjs/Observable';
import {getCollection, getId} from '../../core-utilities/domain/ReduxUtils';
import {makeActionCreator} from '../../core-utilities/redux';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {ORGANIZATION_COLLECTION} from '../../organizations/domain/config';
import {logger} from './logger';


export const showContextMenu = makeActionCreator('context-menu', 'show');
export const showContextMenuByPermission = makeActionCreator('context-menu', 'showByPermission');

export const epics = [
  onShowContextMenu,
  onShowContextMenuByPermission,
];

onShowContextMenu.$inject = [
  '$contextMenu',
];

onShowContextMenuByPermission.$inject = [
  '$contextMenu',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param {Object} dependencies
 * @return {Observable.<ReduxAction>}
 */
export function onShowContextMenu(action$, store, dependencies) {
  return action$.ofType(showContextMenu.TYPE)
    .map(action => dependencies.$contextMenu.show(action.payload))
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onShowContextMenu'));
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param {Object} dependencies
 * @return {Observable.<ReduxAction>}
 */
export function onShowContextMenuByPermission(action$, store, dependencies) {
  return action$.ofType(showContextMenuByPermission.TYPE)
    .map(action => {
      const $contextMenu = dependencies.$contextMenu;
      const actions = [];
      const payload = action.payload;

      payload.actions.forEach(contextAction => {
        const orgId = getId(contextAction.target);
        switch (getCollection(contextAction.target)) {
          case ORGANIZATION_COLLECTION:
            $contextMenu.addActionByOrg(actions, orgId, contextAction);
            break;

          default:
            $contextMenu.addAction(actions, contextAction);
        }
      });

      return {
        actions,
        payload,
      };
    })
    .switchMap(({actions, payload}) => Observable.fromPromise(
      dependencies.$contextMenu
        .showByPermission({
          ...payload,
          actions,
        })
        // Ignore canceled menu rejection
        .catch(() => null)
    ))
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onShowContextMenuByPermission'));
}



// WEBPACK FOOTER //
// ./src/js/core-components/context-menu/redux.js